(function () {
  'use strict';

  function readCfg() {
    var el = document.querySelector('[data-bh-cart-config]');
    if (!el) return null;
    var d = el.dataset;
    return {
      freeThreshold: parseFloat(d.bhFreeThreshold) || 0,
      shipFee: parseFloat(d.bhShipFee) || 0,
      cutH: parseInt(d.bhCutH, 10) || 15,
      cutM: parseInt(d.bhCutM, 10) || 0,
      hols: d.bhHols || '',
      wh: (d.bhWh || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      exact: d.bhExact === 'true',
      splitTxt: d.bhSplitTxt || '',
      fOwn: d.bhFOwn || 'Bonherre tarafından hazırlanır.',
      fOther: d.bhFOther || '{brand} tarafından gönderilir.',
      tFree: d.bhTFree || 'Kargo Bedava',
      tPaid: d.bhTPaid || 'Kargo ücreti',
      tPre: d.bhTPre || 'Ön sipariş ürünü — tedarik sürecinde kargoya verilecek.',
      tToday: d.bhTToday || 'Bugün kargoda',
      tTmrw: d.bhTTmrw || 'Yarın kargoda',
      tDateFmt: d.bhTDateFmt || '{date} tarihinde kargoya verilir',
      tEstPfx: d.bhTEstPfx || 'Tahmini kargoya teslim:',
      tBizD: d.bhTBizD || '{n} iş günü içinde kargoda',
      tSepet: d.bhTSepet || 'Sepet',
      tCheckout: d.bhTCheckout || 'Siparişi Tamamla',
      tViewCart: d.bhTViewCart || 'Sepete Git',
      tContinue: d.bhTContinue || 'Alışverişe devam et',
      tCouponTitle: d.bhTCouponTitle || 'İndirim Kodu / Kupon Kullan',
      tCouponBtn: d.bhTCouponBtn || 'Uygula',
      tCouponPh: d.bhTCouponPh || 'Kupon kodu',
      tNoteTitle: d.bhTNoteTitle || 'Sipariş Notu',
      tNotePh: d.bhTNotePh || 'Siparişiniz hakkında not…',
      tTotal: d.bhTTotal || 'Toplam',
      tSubtotal: d.bhTSubtotal || 'Sepet Tutarı',
      tDiscount: d.bhTDiscount || 'Kampanya İndirimi',
      tShipping: d.bhTShipping || 'Kargo Ücreti',
      tGrandTotal: d.bhTGrand || 'Genel Toplam',
      tSummary: d.bhTSummary || 'Sipariş Özeti',
      tSecure: d.bhTSecure || 'Güvenli Ödeme Altyapısı',
      tEmpty: d.bhTEmpty || 'Sepetiniz boş',
      tStartShop: d.bhTStart || 'Alışverişe Başla',
      tRemaining: d.bhTRemaining || 'Ücretsiz kargoya {amount} kaldı',
      tDelete: d.bhTDelete || 'Kaldır',
      tLimit: d.bhTLimit || 'Sepetindeki ürün için üst limit var, daha fazla artıramazsın.',
      contUrl: d.bhContUrl || '/',
      ratio: d.bhRatio || '1/1',
    };
  }

  var C = null;

  function pH(r) {
    if (!r || !r.trim()) return new Set();
    return new Set(r.split(',').map(function (s) { return s.trim(); }).filter(Boolean));
  }

  function fmt(c) {
    if (typeof c === 'string') c = parseFloat(c);
    if (isNaN(c) || c == null) return '0 TL';
    var a = (c / 100);
    var p = a.toFixed(2).split('.');
    var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return p[1] === '00' ? (i + ' TL') : (i + ',' + p[1] + ' TL');
  }

  function hz(s) {
    return (!s) ? '' : s.toString().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').replace(/I/g, 'i')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function bUrl(v) { return '/collections/' + hz(v); }

  function normT(s) {
    return s.toLowerCase()
      .replace(/İ/gi, 'i').replace(/ı/g, 'i')
      .replace(/ü/g, 'u').replace(/ö/g, 'o')
      .replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ğ/g, 'g')
      .replace(/\u0307/g, '');
  }
  function isWh(b) {
    var nb = normT(b);
    return C.wh.some(function (w) { return normT(w) === nb; });
  }
  function grp(items) {
    var g = {}, o = [];
    items.forEach(function (it) {
      var b = it.vendor || 'Diğer';
      if (!g[b]) { g[b] = []; o.push(b); }
      g[b].push(it);
    });
    return { g: g, o: o };
  }
  function getWhCount(brands) {
    var w = new Set(); var hasOwn = false;
    brands.forEach(function (b) {
      if (isWh(b)) hasOwn = true;
      else w.add(normT(b));
    });
    return w.size + (hasOwn ? 1 : 0);
  }
  function fLbl(b) { return isWh(b) ? C.fOwn : C.fOther.replace('{brand}', b); }

  /* ═══════════════════════════════════════════
     IMAGE RATIO HELPERS
     Convert ratio string (e.g. "1/1", "4/5") to
     Shopify crop dimensions and CSS aspect-ratio.
     ═══════════════════════════════════════════ */
  function getCropDims(ratio, baseSize) {
    baseSize = baseSize || 300;
    var parts = (ratio || '1/1').split('/');
    var w = parseInt(parts[0], 10) || 1;
    var h = parseInt(parts[1], 10) || 1;
    var cropW = baseSize;
    var cropH = Math.round(baseSize * (h / w));
    var pb = ((h / w) * 100).toFixed(4);
    return { w: cropW, h: cropH, css: w + '/' + h, pb: pb, rw: w, rh: h };
  }

  /* Calculate explicit pixel height from a pixel width and ratio */
  function calcHeight(widthPx, ratio) {
    var parts = (ratio || '1/1').split('/');
    var w = parseInt(parts[0], 10) || 1;
    var h = parseInt(parts[1], 10) || 1;
    return Math.round(widthPx * (h / w));
  }

  function cropImg(url, ratio) {
    if (!url) return '';
    var dims = getCropDims(ratio);
    var cropStr = '_' + dims.w + 'x' + dims.h + '_crop_center';
    return url.replace(/(\.\w+)(\?|$)/, cropStr + '$1$2');
  }

  // --- Kargo Tahmini ---
  function sLbl(ks, hol) {
    if (ks === 'onsatis' || ks === 'ön satış') return { t: C.tPre, c: 'pre' };
    var now = new Date();
    var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    var ist = new Date(utc + (3600000 * 3));
    var N = parseInt(ks, 10);
    if (isNaN(N) || N < 0) N = 1;
    if (N > 30) N = 30;
    var bCut = ist.getHours() < C.cutH || (ist.getHours() === C.cutH && ist.getMinutes() <= C.cutM);
    var targetDate = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
    if (N === 0) { if (!bCut) targetDate.setDate(targetDate.getDate() + 1); }
    else { targetDate.setDate(targetDate.getDate() + N); }
    function isOff(d) {
      var w = d.getDay();
      if (w === 0 || w === 6) return true;
      var dStr = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      return hol.has(dStr);
    }
    var loops = 0;
    while (isOff(targetDate) && loops < 20) { targetDate.setDate(targetDate.getDate() + 1); loops++; }
    var baseDate = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
    var df = Math.round((targetDate - baseDate) / 864e5);
    if (df === 0) return { t: C.tToday, c: 'td' };
    if (df === 1) return { t: C.tTmrw, c: 'tm' };
    var months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
    var days = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
    return { t: targetDate.getDate() + ' ' + months[targetDate.getMonth()] + ' ' + days[targetDate.getDay()] + ' kargoda', c: 'sn' };
  }

  // --- Qty HTML ---
  function qH(k, n) {
    return '' +
      '<div class="bq">' +
      '<button type="button" class="bq__b" data-bh-m="' + k + '"' + (n <= 1 ? ' disabled' : '') + '>&minus;</button>' +
      '<input type="number" class="bq__i" value="' + n + '" min="0" data-bh-qi="' + k + '">' +
      '<button type="button" class="bq__b" data-bh-p="' + k + '">+</button>' +
      '</div>';
  }

  // --- Birim Karşılaştırma Fiyatı Al ---
  function getLineComparePrice(it) {
    var meta = window.__bhMeta && (window.__bhMeta[it.variant_id] || window.__bhMeta[it.key]) || {};
    var metaCp = meta.cp ? parseFloat(meta.cp) : 0;
    var unitOrig = it.original_line_price / Math.max(1, it.quantity);
    var cp = metaCp > 0 ? metaCp : unitOrig;
    if (cp < unitOrig) cp = unitOrig;
    return cp;
  }

  function dItem(it, hol) {
    // ✅ FIX v7.5: Explicit height on image wrapper — immune to theme overrides
    var img = cropImg(it.image, C.ratio);
    var iwHeight = calcHeight(90, C.ratio); // drawer image width = 90px

    var vt = it.variant_title || ''; if (vt === 'Default Title') vt = '';
    var ks = (window.__bhMeta && (window.__bhMeta[it.variant_id] || window.__bhMeta[it.key]) || {}).ks
      || (it.properties && it.properties._kargo_suresi) || '1';
    var sh = sLbl(ks, hol);

    var cp = getLineComparePrice(it);
    var line_cp = cp * it.quantity;
    var line_sp = it.final_line_price;

    var ph = (line_cp > line_sp)
      ? '<span class="bc__pr-new">' + fmt(line_sp) + '</span><s class="bc__pr-old">' + fmt(line_cp) + '</s>'
      : '<span class="bc__pr-new">' + fmt(line_sp) + '</span>';

    return '' +
      '<div class="bc__it" data-line-key="' + it.key + '">' +
      '<a href="' + it.url + '" class="bc__iw" style="height:' + iwHeight + 'px"><img src="' + (img || '') + '" alt="" loading="lazy" class="bc__im"></a>' +
      '<div class="bc__inf">' +
      '<div class="bc__inf-top">' +
      '<div class="bc__top-row">' +
      '<a href="' + it.url + '" class="bc__tt">' + it.product_title + '</a>' +
      '<div class="bc__pr">' + ph + '</div>' +
      '</div>' +
      (vt ? '<div class="bc__vr">' + vt + '</div>' : '') +
      (it.line_level_discount_allocations && it.line_level_discount_allocations.length
        ? it.line_level_discount_allocations.map(function (d) { return '<div class="bc__disc">' + d.discount_application.title + '</div>'; }).join('')
        : '') +
      '<div class="bc__deliv">' + sh.t + '</div>' +
      '</div>' +
      '<div class="bc__inf-bot">' +
      qH(it.key, it.quantity) +
      '<button type="button" class="bc__rm-txt" data-bh-rm="' + it.key + '">' + C.tDelete + '</button>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  function pItem(it, hol) {
    // ✅ FIX v7.5: Explicit height on image wrapper
    var img = cropImg(it.image, C.ratio);
    var iwHeight = calcHeight(110, C.ratio); // page image width = 110px

    var vt = it.variant_title || ''; if (vt === 'Default Title') vt = '';

    var cp = getLineComparePrice(it);
    var unit_sp = it.final_line_price / Math.max(1, it.quantity);
    var unit_ph = (cp > unit_sp)
      ? '<span class="bp__pw">' + fmt(cp) + '</span> <span class="bp__pn">' + fmt(unit_sp) + '</span>'
      : '<span class="bp__pn">' + fmt(unit_sp) + '</span>';

    var ks = (window.__bhMeta && (window.__bhMeta[it.variant_id] || window.__bhMeta[it.key]) || {}).ks
      || (it.properties && it.properties._kargo_suresi) || '1';
    var sh = sLbl(ks, hol);
    var fl = fLbl(it.vendor || 'Diğer');

    return '' +
      '<div class="bp__it" data-line-key="' + it.key + '">' +
      '<div class="bp__c1">' +
      '<a href="' + it.url + '" class="bp__iw" style="height:' + iwHeight + 'px"><img src="' + (img || '') + '" alt="" loading="lazy" class="bp__im"></a>' +
      '<div class="bp__info">' +
      '<a href="' + it.url + '" class="bp__tt">' + it.product_title + '</a>' +
      (vt ? '<div class="bp__vr">' + vt + '</div>' : '') +
      '<div class="bp__deliv">' + sh.t + '</div>' +
      '<div class="bp__ftxt">' + fl + '</div>' +
      '<div class="bp__act">' +
      qH(it.key, it.quantity) +
      '<button type="button" class="bp__rm-txt" data-bh-rm="' + it.key + '">' + C.tDelete + '</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="bp__c4">' + unit_ph + '</div>' +
      '<div class="bp__c6"><span class="bp__pn">' + fmt(it.final_line_price) + '</span></div>' +
      '</div>';
  }

  // --- DOĞRU ÖZET & İNDİRİM HESABI ---
  function getCartTotals(cart) {
    // Always calculate from items — cart.total_price can be unreliable
    // (theme scripts, apps, or race conditions may pollute it)
    var itemsTotal = (cart.items || []).reduce(function (s, it) {
      return s + (it.final_line_price || 0);
    }, 0);

    // Use items-based total as primary, cart.total_price only if items sum is 0
    var after = itemsTotal > 0 ? itemsTotal : (cart.total_price || 0);

    // Calculate original from meta compare_at_prices
    var realOriginal = 0;
    (cart.items || []).forEach(function(it) {
      var cp = getLineComparePrice(it);
      realOriginal += (cp * it.quantity);
      /* DEBUG */ console.log('[BHC DEBUG] item:', it.product_title, '| vid:', it.variant_id, '| key:', it.key, '| meta:', JSON.stringify(window.__bhMeta[it.variant_id] || window.__bhMeta[it.key] || 'NONE'), '| cp:', cp, '| qty:', it.quantity, '| final_line:', it.final_line_price, '| orig_line:', it.original_line_price);
    });

    if (realOriginal < after) realOriginal = after;
    var discount = realOriginal - after;

    // Fallback: use Shopify's own fields if our meta missed the discount
    if (discount === 0 && cart.original_total_price && cart.original_total_price > after) {
      realOriginal = cart.original_total_price;
      discount = realOriginal - after;
    }
    if (discount === 0 && cart.total_discount && cart.total_discount > 0) {
      discount = cart.total_discount;
      realOriginal = after + discount;
    }

    /* DEBUG */ console.log('[BHC DEBUG] TOTALS: original:', realOriginal, '| after:', after, '| discount:', discount, '| cart.total_price:', cart.total_price, '| cart.original_total_price:', cart.original_total_price, '| cart.total_discount:', cart.total_discount, '| itemsTotal:', itemsTotal);

    var free = (C.freeThreshold > 0 && after >= C.freeThreshold);
    var ship = free ? 0 : (C.shipFee > 0 ? C.shipFee : 0);
    var grand = after + ship;

    return { original: realOriginal, after: after, discount: discount, free: free, ship: ship, grand: grand };
  }

  function ensureDrawerHeader() {
    var drawer = document.getElementById('bh-cart-drawer');
    if (!drawer) return;
    var panel = drawer.querySelector('.bh-cd__panel');
    if (!panel) return;

    if (panel.querySelector('.bh-cd__header')) return;

    var header = document.createElement('div');
    header.className = 'bh-cd__header';
    header.innerHTML = '' +
      '<span class="bh-cd__header-title">' + C.tSepet + '</span>' +
      '<button type="button" class="bh-cd__close" data-bh-cd-close aria-label="Kapat">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>';

    panel.insertBefore(header, panel.firstChild);
  }

  function renderDrawer(cart) {
    var body = document.getElementById('bh-cd-body');
    var footer = document.getElementById('bh-cd-footer');
    if (!body) return;

    ensureDrawerHeader();
    nukeThemeDrawerTitles();

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="bc__empty"><p>' + C.tEmpty + '</p><a href="' + (C.contUrl || '/') + '" class="bc__ebtn" data-bh-cd-close>' + C.tStartShop + '</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    var hol = pH(C.hols);
    var bd = grp(cart.items);
    var split = getWhCount(bd.o) > 1;

    var h = '';
    if (split && C.splitTxt) {
      h += '<div class="bc__notice"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> <span>' + C.splitTxt + '</span></div>';
    }

    bd.o.forEach(function (brand) {
      var items = bd.g[brand];
      h += '<div class="bc__grp"><div class="bc__gh"><a href="' + bUrl(brand) + '" class="bc__gn">' + brand + '</a></div>';
      items.forEach(function (it) { h += dItem(it, hol); });
      h += '</div>';
    });

    var noteH = '' +
      '<div class="bc__note-wrap">' +
      '<button type="button" class="bc__note-tog" data-bh-tog="dn" aria-expanded="false">' +
      '<span class="bc__note-tog-l"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg> ' + C.tNoteTitle + '</span>' +
      '<svg class="bc__cv" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</button>' +
      '<div class="bc__abd-n" data-bh-bd="dn"><div class="bc__note-inner"><textarea class="bc__d-note" placeholder="' + C.tNotePh + '" id="bh-note">' + (cart.note || '') + '</textarea></div></div>' +
      '</div>';

    body.innerHTML = '<div class="bc__items">' + h + '</div>' + noteH;

    if (footer) {
      footer.style.display = '';
      rFooter(cart, footer);
    }
  }

  function nukeThemeDrawerTitles() {
    var drawer = document.getElementById('bh-cart-drawer');
    if (!drawer) return;
    var els = drawer.querySelectorAll('h1, h2, h3, h4, h5, h6, .drawer__heading, .drawer-title, .cart__title, .cart-drawer__header');
    els.forEach(function(el) {
      if(!el.closest('.bh-cd__header')) el.style.display = 'none';
    });
  }

  function rFooter(cart, el) {
    var t = getCartTotals(cart);

    var totBar = '' +
      '<button type="button" class="bc__totbar" data-bh-tog="sum" aria-expanded="false">' +
        '<span class="bc__totbar-l">' + C.tSummary + '</span>' +
        '<span class="bc__totbar-r">' + fmt(t.grand) + '</span>' +
        '<svg class="bc__cv" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</button>';

    var summaryLines = '' +
      '<div class="bc__sum-bd" data-bh-bd="sum">' +
        '<div class="bc__summary">' +
          '<div class="bc__summary-row"><span>' + C.tSubtotal + '</span><span>' + fmt(t.original) + '</span></div>' +
          (t.discount > 0
            ? '<div class="bc__summary-row bc__summary-row--disc"><span>' + C.tDiscount + '</span><span>-' + fmt(t.discount) + '</span></div>'
            : '') +
          '<div class="bc__summary-row' + (t.free ? ' bc__summary-row--free' : '') + '">' +
            '<span>' + C.tShipping + '</span>' +
            '<span>' + (t.free ? '0 TL' : (C.shipFee > 0 ? fmt(C.shipFee) : 'Hesaplanacak')) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    var actions = '' +
      '<div class="bc__bbar-actions">' +
        '<a href="/checkout" class="bc__bbar-cta">' + C.tCheckout + '</a>' +
        '<a href="/cart" class="bc__bbar-vc">' + C.tViewCart + '</a>' +
      '</div>';

    el.innerHTML = totBar + summaryLines + actions;
  }

  function renderPage(cart) {
    var pg = document.querySelector('[data-bh-cart-page]');
    if (!pg) return;
    var il = pg.querySelector('[data-bh-pg-items]');
    var sl = pg.querySelector('[data-bh-pg-sum]');
    if (!il) return;

    if (!cart.items || !cart.items.length) {
      il.innerHTML = '<div class="bp__empty"><p>' + C.tEmpty + '</p><a href="' + (C.contUrl || '/') + '" class="bc__ebtn">' + C.tStartShop + '</a></div>';
      if (sl) sl.style.display = 'none';
      return;
    }
    if (sl) sl.style.display = '';

    var hol = pH(C.hols);
    var bd = grp(cart.items);
    var split = getWhCount(bd.o) > 1;

    var h = '<div class="bp__hdr"><span>Ürünler</span><span>Birim Fiyat</span><span>Tutar</span></div>';
    bd.o.forEach(function (brand) {
      var items = bd.g[brand];
      h += '<div class="bp__grp"><div class="bp__gh"><a href="' + bUrl(brand) + '" class="bp__gn">' + brand + '</a></div>';
      items.forEach(function (it) { h += pItem(it, hol); });
      h += '</div>';
    });

    var nH = '<div class="bp__note-wrap"><label class="bp__note-lbl" for="bh-note-pg">' + C.tNoteTitle + '</label><textarea id="bh-note-pg" class="bp__note-input" data-bh-pn placeholder="' + C.tNotePh + '">' + (cart.note || '') + '</textarea></div>';
    h += nH + '<div class="bp__continue-wrap"><a href="' + (C.contUrl || '/') + '" class="bp__cont">&larr; ' + C.tContinue + '</a></div>';

    il.innerHTML = h;
    if (sl) rSum(cart, sl, split);
  }

  function rSum(cart, el, split) {
    var t = getCartTotals(cart);

    var h = '<div class="bp__sum"><h3 class="bp__stt">' + C.tSummary + '</h3>';

    if (split && C.splitTxt) {
      h += '<div class="bp__notice"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> <span>' + C.splitTxt + '</span></div>';
    }

    h += '<div class="bp__slines">' +
      '<div class="bp__sr"><span>' + C.tSubtotal + '</span><span>' + fmt(t.original) + '</span></div>' +
      (t.discount > 0 ? '<div class="bp__sr bp__sr--d"><span>' + C.tDiscount + '</span><span>-' + fmt(t.discount) + '</span></div>' : '') +
      '<div class="bp__sr' + (t.free ? ' bp__sr--free' : '') + '"><span>' + C.tShipping + '</span><span>' + (t.free ? '0 TL' : (C.shipFee > 0 ? fmt(C.shipFee) : 'Hesaplanacak')) + '</span></div>' +
      '<div class="bp__sr bp__sr--t"><span>' + C.tGrandTotal + '</span><span>' + fmt(t.grand) + '</span></div>' +
      '</div>';

    h += '<a href="/checkout" class="bp__cta">' + C.tCheckout + '</a>';
    h += '<div class="bp__sec"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> ' + C.tSecure + '</div>';

    var tabs = window.__bhCartTabs || [];
    if (tabs.length) {
      h += '<div class="bp__tabs">';
      tabs.forEach(function (t2, i) {
        h += '<div class="bp__tab">' +
          '<button type="button" class="bp__tbn" data-bh-tog="t' + i + '" aria-expanded="false">' +
          '<span>' + t2.title + '</span>' +
          '<svg class="bc__cv" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="6 9 12 15 18 9"/></svg>' +
          '</button>' +
          '<div class="bc__abd" data-bh-bd="t' + i + '">' + t2.content + '</div>' +
          '</div>';
      });
      h += '</div>';
    }

    h += '</div>';
    el.innerHTML = h;
  }

  function showLimitError(key) {
    var newEl = document.querySelector('[data-line-key="' + key + '"]');
    if (newEl) {
      newEl.style.opacity = '1';
      var err = document.createElement('div');
      err.className = 'bc__err';
      err.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> <span>' + C.tLimit + '</span>';
      var inf = newEl.querySelector('.bc__inf-bot') || newEl.querySelector('.bp__act');
      if (inf) inf.appendChild(err);
      setTimeout(function () { if (err.parentNode) err.remove(); }, 4000);
    }
  }

  window.__bhMeta = window.__bhMeta || {};

  /**
   * Fetch meta for cart items missing from __bhMeta.
   * Groups by handle to avoid duplicate product fetches.
   * Ensures compare_at_price is always preferred over price for cp.
   */
  function fetchMissingMeta(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);

    /* Collect unique handles that need fetching */
    var handleMap = {};
    cart.items.forEach(function(it) {
      if (!window.__bhMeta[it.variant_id]) {
        if (!handleMap[it.handle]) handleMap[it.handle] = [];
        handleMap[it.handle].push(it.variant_id);
      }
    });

    var handles = Object.keys(handleMap);
    if (!handles.length) return Promise.resolve(cart);

    var promises = handles.map(function(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          (handleMap[handle] || []).forEach(function(vid) {
            var v = p.variants.find(function(vr) { return vr.id === vid; });
            if (v) {
              /* Always prefer compare_at_price when it's higher than price */
              var cpVal = (v.compare_at_price && v.compare_at_price > v.price)
                ? v.compare_at_price
                : v.price;
              window.__bhMeta[vid] = {
                cp: cpVal,
                mx: v.inventory_quantity || 9999,
                ks: '1'
              };
            }
          });
        }).catch(function() {});
    });
    return Promise.all(promises).then(function() { return cart; });
  }

  var Q = Promise.resolve();

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return fetchMissingMeta(c); })
      .then(function (c) {
        renderDrawer(c);
        bub(c);
        if (document.querySelector('[data-bh-cart-page]')) renderPage(c);
        return c;
      })
      .catch(function (e) { console.warn('[BHC]', e); return null; });
  }
  window.__bhCartFetch = fetchCart;

  function chg(key, qty) {
    var reqQty = qty;
    var el = document.querySelector('[data-line-key="' + key + '"]');
    if (el) el.style.opacity = '.4';

    Q = Q.then(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: reqQty }),
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { return fetchMissingMeta(c); })
        .then(function (c) {
          if (c && c.status === 422) {
            return fetchCart().then(function () {
              showLimitError(key);
            });
          }
          renderDrawer(c);
          bub(c);
          if (document.querySelector('[data-bh-cart-page]')) renderPage(c);

          var item = c.items && c.items.find(function (i) { return i.key === key; });
          if (item && item.quantity < reqQty) showLimitError(key);
        })
        .catch(function (e) {
          console.warn('[BHC]', e);
          if (el) el.style.opacity = '1';
        });
    });
  }

  function sNote(n) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: n }),
      credentials: 'same-origin'
    }).catch(function () { });
  }

  function bub(c) {
    var b = document.querySelector('[data-bh-cart-count]');
    if (b) b.textContent = c.item_count > 0 ? c.item_count : '';
    nukeThemeDrawerTitles();
  }

  var nT = null;

  function initEv() {
    if (window.__bhCEv) return;
    window.__bhCEv = true;

    document.addEventListener('click', function (e) {
      // qty -
      var m = e.target.closest('[data-bh-m]');
      if (m) {
        var k = m.dataset.bhM;
        var i = document.querySelector('[data-bh-qi="' + k + '"]');
        if (i) {
          var v = parseInt(i.value, 10) || 1;
          chg(k, v > 1 ? v - 1 : 0);
        }
        return;
      }

      // qty +
      var p = e.target.closest('[data-bh-p]');
      if (p) {
        var k2 = p.dataset.bhP;
        var i2 = document.querySelector('[data-bh-qi="' + k2 + '"]');
        if (i2) chg(k2, (parseInt(i2.value, 10) || 1) + 1);
        return;
      }

      // remove
      var rm = e.target.closest('[data-bh-rm]');
      if (rm) { chg(rm.dataset.bhRm, 0); return; }

      // accordion
      var tg = e.target.closest('[data-bh-tog]');
      if (tg) {
        var bd = tg.nextElementSibling;
        if (bd && bd.hasAttribute('data-bh-bd')) {
          var op = bd.classList.contains('is-open');
          if (!op) { bd.classList.add('is-open'); tg.setAttribute('aria-expanded', 'true'); }
          else { bd.classList.remove('is-open'); tg.setAttribute('aria-expanded', 'false'); }
        }
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var i = e.target.closest('[data-bh-qi]');
      if (i) {
        var v = parseInt(i.value, 10) || 0;
        chg(i.dataset.bhQi, v < 1 ? 0 : v);
      }
    });

    document.addEventListener('input', function (e) {
      if (e.target.id === 'bh-note' || e.target.id === 'bh-note-pg' || e.target.hasAttribute('data-bh-pn')) {
        clearTimeout(nT);
        nT = setTimeout(function () { sNote(e.target.value); }, 600);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var w = document.getElementById('bh-cart-drawer');
        if (w && w.classList.contains('is-open')) {
          w.classList.remove('is-open');
          document.body.style.overflow = '';
          document.body.classList.remove('bh-scroll-locked');
        }
      }
    });
  }

  function interceptCartIcon() {
    var isCP = !!document.querySelector('[data-bh-cart-page]');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bh-cart-trigger]');
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (isCP) return;
      if (typeof window.__bhOpenCartDrawer === 'function') window.__bhOpenCartDrawer();
      fetchCart();
    }, true);

    document.addEventListener('click', function (e) {
      var cl = e.target.closest('[data-bh-cd-close]');
      if (!cl) return;
      var drawer = document.getElementById('bh-cart-drawer');
      if (drawer && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
        document.body.classList.remove('bh-scroll-locked');
      }
    }, true);
  }

  function hookFetch() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var isAdd = arguments[0] && typeof arguments[0] === 'string' && arguments[0].indexOf('/cart/add') !== -1;
      return origFetch.apply(this, arguments).then(function (res) {
        if (isAdd && res.ok) {
          res.clone().json().then(function () {
            var isCP = !!document.querySelector('[data-bh-cart-page]');
            if (isCP) {
              fetchCart();
            } else {
              if (typeof window.__bhOpenCartDrawer === 'function') window.__bhOpenCartDrawer();
              fetchCart();
            }
          }).catch(function () { });
        }
        return res;
      });
    };
  }

  function init() {
    C = readCfg();
    if (!C) return;

    document.documentElement.style.setProperty('--bh-cart-ratio', C.ratio);
    document.documentElement.style.setProperty('--bh-cart-img-ratio', C.ratio);

    initEv();
    interceptCartIcon();
    hookFetch();

    var p = setInterval(function () {
      if (typeof window.__bhRefreshAndOpenCartDrawer === 'function') {
        clearInterval(p);
        window.__bhRefreshAndOpenCartDrawer = function () { };
      }
    }, 50);
    setTimeout(function () { clearInterval(p); }, 8000);

    if (document.querySelector('[data-bh-cart-page]')) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { return fetchMissingMeta(c); })
        .then(function (c) { renderPage(c); bub(c); });
    }

    nukeThemeDrawerTitles();
  }

  window.__bhCartRender = function (c) {
    if (!C) C = readCfg();
    fetchMissingMeta(c).then(function (cartWithMeta) {
      renderDrawer(cartWithMeta);
      if (document.querySelector('[data-bh-cart-page]')) renderPage(cartWithMeta);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();